import { render, staticRenderFns } from "./dispute-form.vue?vue&type=template&id=2352b73c&"
import script from "./dispute-form.vue?vue&type=script&lang=js&"
export * from "./dispute-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports